import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { ConsultaSerasaRow } from 'src/modules/motor-credito/serasa/serasa.pj.types'

export type ConsultasProps = {
    consultas: ConsultaSerasaRow[]
}

export default function Consultas({ consultas }: ConsultasProps) {
    return (
        <>
            <Divider textAlign="center">Consultas</Divider>
            {consultas && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    {consultas.map((consulta, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label={`Mês: ${consulta.mes}`} value={consulta.qtde.toFixed(0)} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
